import { PageLoader } from '../../Page'
import { useUserProfileContext } from '../User.hooks'

function UserProfileLoader() {
  const { isInitiated, isLoading, isPerformingAction } = useUserProfileContext()

  return (isLoading || isPerformingAction) && isInitiated ? (
    <PageLoader />
  ) : null
}

export default UserProfileLoader
